import GARepository from './GARepository';
import TrackingAdapter from './TrackingAdapter';
import GATracker from './GATracker';
import { gaTrackingFactory, GaTracking, InteractionInputEvent } from './GaTracking';

const isWindow = typeof window !== 'undefined';

const windowObject = isWindow ? (window as any) : undefined;
const gaRepository = isWindow ? new GARepository(windowObject.platformData) : undefined;
const gaTrackingAdapter = isWindow ? new TrackingAdapter(gaRepository) : undefined;
const gaTracking = isWindow ? gaTrackingFactory(gaTrackingAdapter, gaRepository) : undefined;

function getGASession(): GATracker | undefined {
  if (isWindow) {
    const googleAnalyticsObject = windowObject.GoogleAnalyticsObject;
    return new GATracker(window, googleAnalyticsObject);
  }
  return undefined;
}

export { GaTracking, gaTracking, gaRepository, gaTrackingAdapter, getGASession, InteractionInputEvent };
